/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc
 */

export const LoginVerifyErrorInternalResponseTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.LoginVerifyErrorInternalResponse';
export const LoginVerifyErrorUnauthenticatedResponseTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.LoginVerifyErrorUnauthenticatedResponse';
export const LoginVerifySuccessResponseTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.LoginVerifySuccessResponse';
export const placeholderMethodRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'placeholderMethod',
  auth: 'external',
  fingerprint: 'ycAIvrze_8cgOfvOGN1AGs9i0kjEFy8C',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const loginVerifyAnnotatedRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'loginVerifyAnnotated',
  auth: 'external',
  fingerprint: 'DrOlx8Pux0pK9x1I5trC6EWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const loginVerifyRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'loginVerify',
  auth: 'external',
  fingerprint: 'DrOlx8Pux0rKG8U34dQOvUWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const authenticatedPortalMethodRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'authenticatedPortalMethod',
  auth: 'external',
  fingerprint: 'cxTuXJMWkkogOfvOGN1AGkWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const dynamicCompanyFetchPortalMethodRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'dynamicCompanyFetchPortalMethod',
  auth: 'external',
  fingerprint: 'cxTuXJMWkkr4yhPUZhxSNFcgdARZo-ft',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const dynamicProjectFetchPortalMethodRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'dynamicProjectFetchPortalMethod',
  auth: 'external',
  fingerprint: 'cxTuXJMWkkrVX2m61RMQKlcgdARZo-ft',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const dynamicProjectsFetchPortalMethodRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'dynamicProjectsFetchPortalMethod',
  auth: 'external',
  fingerprint: 'cxTuXJMWkkqae11wiJzYcEWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updatePreferredLanguageRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'updatePreferredLanguage',
  auth: 'external',
  fingerprint: '82MwACAzkmrEl0ZEms6HPUWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCoursesRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'getCourses',
  auth: 'external',
  fingerprint: 'cxTuXJMWkkrwpRnEkDxw60WCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCourseDetailRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'getCourseDetail',
  auth: 'external',
  fingerprint: 'cxTuXJMWkkrMPSSNR7pa8FcgdARZo-ft',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getLessonContentRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'getLessonContent',
  auth: 'external',
  fingerprint: 'cxTuXJMWkkoqiaq3xbP6X1cgdARZo-ft',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMyLearningRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'getMyLearning',
  auth: 'external',
  fingerprint: 'cxTuXJMWkkq7RrQ9I0wJikWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};